/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddRegulationsFormDto } from '../../models/add-regulations-form-dto';
import { RegulationDto } from '../../models/regulation-dto';

export interface AddRegulations$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * id of risk assessment, which groups regulations
 */
  riskAssessmentId: number;
      body: AddRegulationsFormDto
}

export function addRegulations(http: HttpClient, rootUrl: string, params: AddRegulations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegulationDto>>> {
  const rb = new RequestBuilder(rootUrl, addRegulations.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('riskAssessmentId', params.riskAssessmentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RegulationDto>>;
    })
  );
}

addRegulations.PATH = '/customers/{customerId}/risk-assessment/{riskAssessmentId}/regulations';
